var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"ripple":""}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.item.displayName)+" ")]),_c('v-list-item-subtitle',[_c('a',{attrs:{"href":_vm.item.mailToLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.item.email)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }